import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { IoMdNotifications, IoMdClose } from "react-icons/io";
import { IoMenu } from "react-icons/io5";
import Imagepng from "../components/Image_png";
import Imagewebp from "../components/Image_webp";
import * as colors from "../assets/css/Colors";
import Location from "../modal/Location";
import { LanguageContext } from '../detectlanguage/LanguageContext';
import translate from '../detectlanguage/translate';
import Serverimage from "../components/Serverimage";
import Logout from '../login/Logout';
import './header.css';
import { MdOutlineDomainAdd } from "react-icons/md";
// Image imports
import Img_15 from "./../images/teacher-b.png";
import Img_16 from './../images/reading-b.png';
import Img_17 from './../images/attendance-b.png';
import Img_18 from '../images/exam-b.png';
import Img_19 from './../images/library-b.png';
import Img_20 from './../images/event-b.png';
import Img_21 from './../images/online-conference-b.png';
import Img_22 from './../images/blog-b.png';
import Img_23 from './../images/school-b.png';
import Img_24 from './../images/collage-b.png';

const Header = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAniActive2(false);
    setIsAniActive3(false);
    setIsAniActive4(false);
    navigate('/login');
  };

  const { language, toggleLanguage } = useContext(LanguageContext);
  const [locationName, setLocationName] = useState('');
  const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  const [scrollClass, setScrollClass] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrollClass('dmact');
      } else {
        setScrollClass('');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const element = document.querySelector(".ban-short-links");
    if (element) {
      element.classList.add("ani");
    }
  }, []);

  const [isAniActive1, setIsAniActive1] = useState(false);
  const [isAniActive2, setIsAniActive2] = useState(false);
  const [isAniActive3, setIsAniActive3] = useState(false);
  const [isAniActive4, setIsAniActive4] = useState(false);

  const handleClick1 = () => {
    setIsAniActive1(!isAniActive1);
  };

  const handleClick2 = () => {
    setIsAniActive2(!isAniActive2);
  };

  const handleClick3 = () => {
    setIsAniActive3(!isAniActive3);
  };

  const handleClick4 = () => {
    setIsAniActive4(!isAniActive4);
  };

  const handleCloseClick1 = (event) => {
    event.stopPropagation();
    setIsAniActive1(false);
  };

  const handleCloseClick2 = (event) => {
    event.stopPropagation();
    setIsAniActive2(false);
  };

  const handleCloseClick3 = (event) => {
    event.stopPropagation();
    setIsAniActive3(false);
  };

  const handleCloseClick4 = (event) => {
    event.stopPropagation();
    setIsAniActive4(false);
  };

  return (
    <>
      <div className={`hom-top ${scrollClass}`}>
        <Container>
          <Row>
            <div className="hom-nav db-open">
              <div className="header-main-box">
                <div className="header-brandlogo-menu">
                  <Link to="/" className="top-log">
                    <div className="desktop-view">
                      <Imagewebp text={'do-digital'} />
                    </div>
                    <div className="mobile-view">
                      <Imagewebp text={'do'} />
                    </div>
                  </Link>
                  <div className={isAniActive1 ? "menu ani" : "menu"} onClick={handleClick1} style={{ borderLeft: `2px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}` }}>
                    <h4>Explore</h4>
                  </div>
                </div>
                <div className="top-ser">
                  <ul>
                    <li className="sr-sea">
                      <p style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>
                        Location: {locationName ? locationName : 'Fetching location...'}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="header_right_side_style">
                  {user ? (
                    <>
                      <div style={{ display: 'contents' }}>
                        <div className="top-noti">
                          <div className='location-gif'>
                            <Location onLocationUpdate={setLocationName} />
                          </div>
                          <span
                            className="material-icons db-menu-noti"
                            onClick={handleClick3}
                            style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}
                          >
                            <IoMdNotifications />
                            <i style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_white_color : colors.theme_black_color }}>00</i>
                          </span>

                          <div
                            className={
                              isAniActive3
                                ? "db-noti top-noti-win act"
                                : "db-noti top-noti-win"
                            }
                          >
                            <span
                              className="material-icons db-menu-clo"
                              onClick={handleCloseClick3}
                            >
                              <IoMdClose />
                            </span>
                            <h4>Notifications</h4>
                            <ul id="all-notif-ul"></ul>
                            <span
                              id="no-noti-clr-noti"
                              className="no-noti-clr-noti"
                            >
                              No Notifications to Show
                            </span>
                          </div>
                        </div>
                        <div className="al">
                          <div className="head-pro" onClick={handleClick2}>
                            <Serverimage text={user.user_profile} />
                            <span className="fclick near-pro-cta"></span>
                          </div>
                          <div className={isAniActive2 ? "db-menu act" : "db-menu"}>
                            <span
                              className="material-icons db-menu-clo"
                              onClick={handleCloseClick2}
                            >
                              <IoMdClose />
                            </span>
                            <div className="ud-lhs-s1">
                              <Serverimage text={user.user_profile} />

                              <div className="ud-lhs-pro-bio">
                                <h4 style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>{user.first_name} {user.last_name}</h4>
                                <b>{user.username}</b>
                              </div>
                            </div>
                            <ul>
                              <li>
                                <Link to=":username" className="">
                                  <Imagepng text={'dbl1'} />
                                  My Dashboard
                                </Link>
                              </li>
                              {/* <Logout/> */}
                              <Logout
                                setIsAniActive2={setIsAniActive2}
                                setIsAniActive3={setIsAniActive3}
                                setIsAniActive4={setIsAniActive4}
                              />
                              {/* <li>
                            <Link onClick={handleLogout}>
                              <Imagepng text={'dbl12'} />
                              Log Out
                            </Link>
                          </li> */}
                            </ul>
                          </div>
                        </div>
                        <div className="mob-menu">
                          <div className="mob-me-ic" onClick={handleClick4}>
                            <i className="material-icons">
                              <IoMenu />
                            </i>
                          </div>
                          <div
                            className={
                              isAniActive4
                                ? "mob-me-all mobmenu-show"
                                : "mob-me-all"
                            }
                          >
                            <div className="mob-me-clo">
                              <i
                                className="material-icons"
                                onClick={handleCloseClick4}
                              >
                                <IoMdClose />
                              </i>
                            </div>
                            <div className="ud-lhs-s1">
                              <Serverimage text={user.user_profile} />
                              <div className="ud-lhs-pro-bio">
                                <h4 style={{ color: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>{user.first_name} {user.last_name}</h4>
                                <b>{user.username}</b>
                              </div>
                            </div>
                            <div className="mv-pro-menu ud-lhs-s2">
                              <ul>
                                <li>
                                  <Link to=":username" className="">
                                    <Imagepng text={'dbl1'} />
                                    My Dashboard
                                  </Link>
                                </li>
                                <li>
                                  <Link onClick={handleLogout}>
                                    <Imagepng text={'dbl12'} />
                                    Log Out
                                  </Link>
                                </li>
                              </ul>
                            </div>
                            <div className="mv-cate">
                              <h4>All Categories</h4>
                              <ul>
                                <li>
                                  <Link to="">Real Estate</Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="login-signup-header-menu">
                      <ul className="bl">
                        <li>
                          <div className='location-gif'>
                            <Location onLocationUpdate={setLocationName} />
                          </div>
                        </li>
                        <li>
                          <Link style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }} to="/Login"> {translate('login_user', language)}</Link>
                        </li>
                      </ul>
                    </div>

                  )}
                </div>
              </div>
              <div className={isAniActive1 ? "pop-menu ani" : "pop-menu"}>
                <Container>
                  <Row>
                    <Link onClick={handleCloseClick1} className="clopme">
                      <IoMdClose />
                    </Link>
                    <Col sm={3}>
                      <div className="pmenu-spri">
                        <ul>
                          <li>
                            <Link to="/Students" className="act">
                              <img src={Img_15} />
                              Students
                            </Link>
                          </li>
                          <li>
                            <Link to="/Teachers" className="act">
                              <img src={Img_16} />
                              Teachers
                            </Link>
                          </li>
                          <li>
                            <Link to="/Attendance" className="act">
                              <img src={Img_17} />
                              Attendance
                            </Link>
                          </li>
                          <li>
                            <Link to="" className="act">
                              <img src={Img_18} />
                              Exam
                            </Link>
                          </li>
                          <li>
                            <Link to="" className="act">
                              <img src={Img_19} />
                              Library
                            </Link>
                          </li>
                          <li>
                            <Link to="/Events" className="act">
                              <img src={Img_20} />
                              Events
                            </Link>
                          </li>
                          <li>
                            <Link to="" className="act">
                              <img src={Img_21} />
                              Online Course
                            </Link>
                          </li>
                          <li>
                            <Link to="/Blogs" className="act">
                              <img src={Img_22} />
                              Blogs
                            </Link>
                          </li>
                          <li>
                            <Link to="/Schools" className="act">
                              <img src={Img_23} />
                              Schools
                            </Link>
                          </li>
                          <li>
                            <Link to="/Colleges" className="act">
                              <img src={Img_24} />
                              Collage
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col sm={9}>
                      <div className="pmenu-cat">
                        <h4>All Categories</h4>
                        <input
                          type="text"
                          id="pg-sear"
                          placeholder="Search category"
                        />
                        <ul id="pg-resu">
                          <li>
                            <Link to="">
                              Real Estate&nbsp;-&nbsp;<span>24</span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col sm="12">
                      <div className="dir-home-nav-bot">
                        <ul>
                          <li>
                            Find your Equation needs Help
                            <span>Call us on: +91 7737144320</span>
                          </li>

                          <li>
                            <Link
                              to=""
                              className="waves-effect waves-light btn-large"
                            >
                              <i className="material-icons"><MdOutlineDomainAdd /></i> Add
                              your Schools & Collages
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </Row>
        </Container>
        <span
          className={`bg ${isAniActive2 ? "act" : ""} ${isAniActive3 ? "act" : ""
            } ${isAniActive4 ? "act" : ""}`}
        >
          &nbsp;
        </span>
      </div>

    </>
  );
};

export default Header;
